class Bookmark {
    constructor() {
        function smoothScroll() {
            let x = document.querySelectorAll('a[href="#bookmark"]');
            for (let i = 0; i < x.length; i++) {
                x[i].addEventListener("click", function (event) {
                    event.preventDefault();
                    const y = document.getElementById('bookmark').getBoundingClientRect().top + window.pageYOffset - document.querySelector('.site-header').offsetHeight;
                    window.scrollTo({top: y, behavior: 'smooth'});
                }
                )
            }
        }
        smoothScroll();
    }
}
export default new Bookmark;